"use strict";function resetView$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.resetView$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="device.screen.resetView";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.0.0"},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.0.0"},_a)),exports.resetView$=resetView$,exports.default=resetView$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/device/screen/resetView.js
// module id = 1078
// module chunks = 106